import React from "react";
import { Award } from "lucide-react";
import { ACCREDITATIONS } from "../data";

export default function PressStrip({ variant = "light" }) {
  const dark = variant === "dark";
  return (
    <section
      data-testid="press-strip"
      className={`relative ${dark ? "bg-ink text-bone border-y border-bone/10" : "bg-boneSoft border-y border-ink/10"}`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10 md:py-14">
        <p className={`section-num inline-flex ${dark ? "text-bone/45" : ""}`}>
          <strong className={dark ? "text-butter" : ""}>·</strong> Recognised &amp; certified
        </p>
        <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-x-6 gap-y-8">
          {ACCREDITATIONS.map((a) => (
            <div key={a.name} className="flex flex-col items-start gap-1.5">
              <div className={`flex items-center gap-2 font-display text-[20px] md:text-[22px] leading-none tracking-tightest ${dark ? "text-bone" : "text-ink"}`}>
                <Award className={`h-4 w-4 ${dark ? "text-butter" : "text-coral"}`} />
                {a.name}
              </div>
              <p className={`text-[11px] tracking-[0.18em] uppercase ${dark ? "text-bone/45" : "text-muted"}`}>
                {a.note}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
